import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import * as Util from "../Utils/Util";
import Hider from "../Utils/Hider";
import ProductState from "./ProductState";

export default class StrengthSelector {
  private readonly element: HTMLElement;
  private readonly productCode: string;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.productCode = Util.getData(element, "productCode");

    Events.on("product-state-change", (s: ProductState) => this.handleChangedState(s));
  }

  private handleChangedState(state: ProductState) {
    const shouldShow = this.productCode == state.product.code;
    Hider.match(this.element, shouldShow);
  }

  public static Factory: DomFactory<StrengthSelector> = (e) => new StrengthSelector(e);
}
